import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Regexs } from '@utils/regex';

@Component({
  selector: 'classify-ras',
  templateUrl: './classify-ras.component.html',
  styleUrls: ['./classify-ras.component.scss'],
})
export class ClassifyRasComponent implements OnInit {
  @Input() data: { task: any };

  constructor(private readonly fb: FormBuilder) {}

  form: FormGroup = this.fb.group({
    ci: ['', [Validators.required, Validators.pattern(Regexs.regexCiRif)]],
    clientName: ['', [Validators.required]],
    clientLastname: ['', [Validators.required]],
    clientType: ['', [Validators.required]],
    clientRegion: ['', [Validators.required]],
    riskLevel: ['', [Validators.required]],
    dateAlert: ['', [Validators.required]],
  });

  ngOnInit() {
    const { task } = this.data;

    const values = task.data;
    if (values) {
      this.form.setValue(values);
    }
  }

  typesOfClient = ['Tipo 1', 'Tipo 2'];

  regionOfClient = ['Region 1', 'Region 2'];
}
